import styles from './Details.module.css';
import {Button} from "../../../common/Button";
import {useContext, useState} from "react";
import {KlashaSelect} from "../../../common/KlashaSelect";
import {ButtonFooter} from "../../../common/ButtonFooter";
import {StatusContext} from "../../../../context/Status";

type paymentOption = {
    value: string;
    label: string;
}

interface OptionsProps {
    paymentOptions: paymentOption[],
    onChange: (bankOption: any) => void,
}

export const Options = ({paymentOptions, onChange} : OptionsProps) => {
    const { setPageTransactionStatus } = useContext(StatusContext);

    const onPaid = () => {
        setPageTransactionStatus('processing')
    }


    return (
        <div className={styles.container}>
            <form>
                <KlashaSelect
                    label="Bank name"
                    onChange={onChange}
                    options={paymentOptions}
                />

                <ButtonFooter>
                    <Button type='button' text="I have paid" buttonStyle="primary" onClick={onPaid} />
                </ButtonFooter>
            </form>
        </div>
    )
}